import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Insta Fire 🔥</h1>
      <h2>Your Pictures</h2>
      <p>This is the collection of all your pictures</p>
    </div>
  )
}

export default Title;